// extracted by mini-css-extract-plugin
export default {"uploadBadge":"styles_uploadBadge__z16sj"};